
export default function WhyActNow() {
  const reasons = [
    {
      icon: 'ri-alarm-warning-line',
      title: '30% Federal Tax Credit Expires Dec 2025',
      desc: "The Inflation Reduction Act's 30% solar tax credit for homeowner-owned systems drops to 0% on January 1, 2026. This is the last year to claim thousands in savings.",
      urgency: true,
    },
    {
      icon: 'ri-arrow-up-double-line',
      title: 'Florida Electricity Rates Are Rising',
      desc: "FPL approved a 4-year rate hike starting 2026. Every month you wait, you're paying more to the utility company instead of investing in your own home.",
      urgency: true,
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Increase Your Home Value',
      desc: 'Solar panels add an average of $20,000-$30,000 to Florida home values. Plus, the added value is 100% property tax exempt.',
      urgency: false,
    },
    {
      icon: 'ri-shield-check-line',
      title: '25-Year Panel Warranty',
      desc: 'Modern solar panels come with 25-year performance warranties and last 30+ years. Your investment is protected for decades.',
      urgency: false,
    },
    {
      icon: 'ri-leaf-line',
      title: 'Reduce Your Carbon Footprint',
      desc: 'A typical 8 kW solar system offsets about 11,000 lbs of CO2 per year — equivalent to planting 180 trees annually.',
      urgency: false,
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Energy Independence',
      desc: 'Stop being at the mercy of utility rate hikes. Lock in your energy costs and gain control over your monthly expenses for decades.',
      urgency: false,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <div className="inline-block bg-brand-red-light text-brand-red px-4 py-2 rounded-full text-xs font-bold mb-3">
          WHY ACT NOW
        </div>
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
          The Window Is Closing
        </h2>
        <p className="text-sm text-gray-600 max-w-2xl mx-auto">
          2025 is the best year to go solar in Florida. Here&apos;s why waiting could cost you thousands.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reasons.map((r, idx) => (
          <div
            key={idx}
            className={`rounded-2xl p-5 border-2 transition-all duration-300 hover:shadow-lg ${
              r.urgency
                ? 'bg-gradient-to-br from-red-50 to-orange-50 border-red-200 hover:border-red-300'
                : 'bg-white border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="flex items-start gap-3">
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${
                  r.urgency ? 'bg-red-100' : 'bg-brand-navy-light'
                }`}
              >
                <i
                  className={`${r.icon} text-xl ${
                    r.urgency ? 'text-red-500' : 'text-brand-navy'
                  }`}
                ></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">{r.title}</h4>
                <p className="text-xs text-gray-600 leading-relaxed">{r.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Financing Note */}
      <div className="bg-gradient-to-r from-brand-navy to-brand-navy-dark rounded-2xl p-6 text-white text-center">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 mx-auto mb-3">
          <i className="ri-bank-card-line text-white text-2xl"></i>
        </div>
        <h4 className="font-bold text-lg mb-2">$0 Down Financing Available</h4>
        <p className="text-sm text-white/80 max-w-xl mx-auto mb-4">
          Start saving from day one with no upfront cost. Many homeowners see
          positive cash flow immediately — your monthly loan payment is less
          than your old electric bill.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <div className="bg-white/10 rounded-xl px-4 py-2">
            <div className="text-xs text-white/60">Typical Monthly Payment</div>
            <div className="text-lg font-bold">$89-$179</div>
          </div>
          <div className="bg-white/10 rounded-xl px-4 py-2">
            <div className="text-xs text-white/60">vs. Average Bill Savings</div>
            <div className="text-lg font-bold">$120-$250+</div>
          </div>
          <div className="bg-white/10 rounded-xl px-4 py-2">
            <div className="text-xs text-white/60">Net Monthly Benefit</div>
            <div className="text-lg font-bold text-green-300">+$31-$71</div>
          </div>
        </div>
      </div>
    </div>
  );
}
